import { AxiosError } from "axios";
import { IGpsSourceRequest } from "@/GpsSource/services";
import { HttpErrorParser } from "@/App/services/HttpErrorParser";
import { LoggerService as lgg } from "vue-components-library";
import { IGpsSourceState } from "@/GpsSource/models";
import {
  gpsCoordsFromNmeaGprmcSentence,
  gpsCoordsFromTaipFormat,
  readConfig,
  writeConfig,
} from "@/GpsSource/store/gps.action.helpers";

const LOG_TAG = "[GPSSOURCE STORE]";
const state: IGpsSourceState = getDefaultState();

function getDefaultState() {
  return {
    errorMessage: null,
    location: null,
    config: window.electron ? readConfig() || null : null,
    isLoading: false,
  };
}

const getters = {
  location: (state: any) => state.location,
  config: (state: any) => state.config,
  gpsConfig: (state: any) => state.config,
};

const actions = {
  saveGpsConfig({ commit, dispatch }: any, data: IGpsSourceRequest) {
    commit("SET_CONFIG", data.preferences["gps"]);
  },
  startListening({ dispatch }: any) {
    if (state.config) {
      lgg.info(`${LOG_TAG} startListening`, state.config);
      if (state.config.portType === "udp4" || state.config.portType === "udp6") {
        dispatch("startListeningUdp");
      } else if (state.config.portType === "tcp") {
        dispatch("startListeningTcp");
      }
    }
  },
  startListeningUdp({ commit, dispatch }: any) {
    if (state.config) {
      lgg.info(`${LOG_TAG} startListeningUdp beginning`);
      try {
        window.electron.startListeningUDP({
          host: state.config.host,
          messageProcessor: processGpsData,
          port: state.config.port,
          portType: state.config.portType,
        });
      } catch (error) {
        lgg.error(`${LOG_TAG} startListeningUdp`, error);
        dispatch("setGeneralError", HttpErrorParser.parse(error as AxiosError<any>));
      }
      lgg.info(`${LOG_TAG} startListeningUdp`);
    }

    function processGpsData(msg: string) {
      if (state.config) {
        if (state.config.dataFormat === "NMEA") {
          if (msg.indexOf("$GPRMC") !== -1) {
            commit("SET_LOCATION", gpsCoordsFromNmeaGprmcSentence(msg.toString()));
          }
        }
        if (state.config.dataFormat === "TAIP") {
          if (msg.indexOf(">") !== -1) {
            commit("SET_LOCATION", gpsCoordsFromTaipFormat(msg.toString()));
          }
        }
      }
    }
  },
  startListeningTcp({ commit, dispatch }: any) {
    let buffered = "";

    if (state.config) {
      lgg.info(`${LOG_TAG} startListeningTcp beginning`);
      const net = window.electron.require("net");
      const listener = net.createConnection({
        port: state.config.port,
        host: state.config.host,
        exclusive: false,
      });
      listener.on("connect", () => {
        listener.on("data", (data) => {
          buffered += data;
          processReceived();
        });
      });
    }
    function processReceived() {
      let received = buffered.split("\n");
      while (received.length > 1) {
        processGpsData(received[0]);
        buffered = received.slice(1).join("\n");
        received = buffered.split("\n");
      }
    }
    function processGpsData(msg: string) {
      if (state.config) {
        if (state.config.dataFormat === "NMEA") {
          if (msg.indexOf("$GPRMC") !== -1) {
            state.location = gpsCoordsFromNmeaGprmcSentence(msg.toString());
          }
        }
        if (state.config.dataFormat === "TAIP") {
          if (msg.indexOf(">") !== -1) {
            state.location = gpsCoordsFromTaipFormat(msg.toString());
          }
        }
      }
    }
  },
  stopListening({ commit }: any, error: any) {
    commit("SET_GENERAL_ERROR", error);
  },
  setGeneralError({ commit }: any, error: any) {
    commit("RESET_STATE");
  },
  resetState({ commit }: any) {
    commit("RESET_STATE");
  },
};
const mutations = {
  SET_GENERAL_ERROR(state: any, message: string) {
    state.errorMessage = message;
  },
  SET_LOADING(state: any, message: string) {
    state.isLoading = message;
  },
  SET_CONFIG(state: any, config: object) {
    state.config = config;
    writeConfig(state.config);
    lgg.info(`${LOG_TAG} SET_CONFIG`, state.config);
  },
  SET_LOCATION(state: any, location: object) {
    state.location = location;
  },
  CLEAR_ERRORS(state: any) {
    state.errorMessage = "";
  },
  RESET_STATE(state: any) {
    const initialState: any = getDefaultState();

    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
